import { useTranslation } from 'react-i18next'

import { Modal } from '@reveni-io/reveni-ui'

import StartStep from './steps/StartStep/StartStep'

const FixInventoryItemsModal = ({ show, onClose, onStart }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Asistente de Inventario con IA')} size="l">
      <StartStep onStart={onStart} />
    </Modal>
  )
}

export default FixInventoryItemsModal
